import ApiService from '@/common/api.service'

const RESOURCE = 'top'
const TopService = {
  get (params) {
    return ApiService.query(RESOURCE, params)
  }
}
export default TopService
